export default "__VITE_ASSET__BkIfNNGj__"